import { useMutation, useQuery } from 'react-query';
import { network } from 'services/network';

const getActivityCodesAliases = (contractId) => {
    return network
        .get(`api/bo/getActivityCodesAliases?contractId=${contractId}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const getActivityCodesByContract = (contractId) => {
    return network
        .get(`api/bo/getActivityCodesByContract?contractId=${contractId}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const createAlias = (params) => {
    return network
        .post('api/bo/createActivityCodeAlias', params)
        .then((response) => response.data)
        .catch((error) => {
            throw error;
        });
};

const deleteAlias = (id) => {
    const url = `api/bo/deleteActivityCodeAliasById?id=${id}`;
    return network
        .post(url)
        .then((response) => response.data)
        .catch((error) => {
            throw error;
        });
};

const editAlias = (params) => {
    return network
        .post('api/bo/updateActivityCodeAlias', params)
        .then((response) => response.data)
        .catch((error) => {
            throw error;
        });
};

const useQueryGetActivityCodesAliases = ({ contractId }) => {
    return useQuery(['useQueryGetActivityCodesAliases', contractId], () => getActivityCodesAliases(contractId), {
        enabled: Boolean(contractId),
    });
};

const useQueryGetActivityCodesByContract = ({ contractId }) => {
    return useQuery<{ scope: string; typeName: string }[], QueryError>(
        ['useQueryGetActivityCodesByContract', contractId],
        () => getActivityCodesByContract(contractId),
        {
            enabled: Boolean(contractId),
        },
    );
};

const useMutationCreateAlias = () => {
    return useMutation<any, QueryError, CreateAliasProps>((params) => createAlias(params));
};

const useMutationDeleteAlias = () => {
    return useMutation<any, QueryError, { id: number | undefined }>((id) => deleteAlias(id));
};

const useMutationEditAlias = () => {
    return useMutation<any, QueryError, EditAliasProps>((params) => editAlias(params));
};

export {
    useQueryGetActivityCodesAliases,
    useQueryGetActivityCodesByContract,
    useMutationCreateAlias,
    useMutationDeleteAlias,
    useMutationEditAlias,
};

interface CreateAliasProps {
    alias: string;
    contractId: number | undefined;
    name: string;
    scope: string;
}

interface EditAliasProps {
    alias: string;
    id: number;
}
